import ActionTypes from '../actions/types'
import {CACHE_ActiveBuildingId} from '../constants/AppConstants'

const initialState = {
  buildingsLookup: {},
  activeBuildingId: undefined,
  sisterBuildingsLookup: {}, // Map of buildingId -> Array<{id, displayName}>
}

// --------------------------------------------------------------------------------
// State permutation functions:

function reduceBuildingsListToObj(state, buildingsList) {
  let buildingObj = buildingsList.reduce((obj, b) => {
    // clone the building object because it may be used by another reducer
    obj[b.building.id] = formatBuildingRecord(b.building)
    return obj
  }, {})

  // Extract sister buildings for each building
  let sisterBuildingsObj = buildingsList.reduce((obj, b) => {
    const sisterBuildingsRaw = b.building?.sisterBuildings || []
    obj[b.building.id] = sisterBuildingsRaw
      .map(sb => ({
        id: sb.sisterBuilding?.id,
        displayName: sb.sisterBuilding?.displayName,
        onboardingSchema: sb.sisterBuilding?.onboardingSchema,
      }))
      .filter(sb => sb.id) // Filter out any null entries
    return obj
  }, {})

  return {...state, buildingsLookup: buildingObj, sisterBuildingsLookup: sisterBuildingsObj}
}

function updateSingleBuilding(state, newBuildingData) {
  let newBuildings = {...state.buildingsLookup}
  // clone the object so it forces a re-render
  newBuildings[newBuildingData.id] = formatBuildingRecord({...newBuildings[newBuildingData.id], ...newBuildingData})
  return {...state, buildingsLookup: newBuildings}
}

function setActiveBuildingById(state, buildingId) {
  if (buildingId) {
    localStorage[CACHE_ActiveBuildingId] = buildingId
  } else {
    delete localStorage[CACHE_ActiveBuildingId]
  }
  return {...state, activeBuildingId: buildingId}
}

function setBuildingDummyResidentId(state, buildingId, dummyResidentId) {
  let newBuildings = {...state.buildingsLookup}
  // clone the object so it forces a re-render
  newBuildings[buildingId] = {...newBuildings[buildingId], dummyResidentId: dummyResidentId}
  return {...state, buildingsLookup: newBuildings}
}

function formatBuildingRecord(buildingRecord) {
  // clone the building object because it may be used by another reducer
  const formattedRecord = {...buildingRecord}

  // if the building has desk hours enabled we need to pretend like they're always in office
  // this effectively disables the OOO warning messages and ensures the input button is always enabled
  if (formattedRecord.deskHoursEnabled) {
    formattedRecord.outOfOfficeStatus = true
  }

  // preserve the org's exit-survey taxonomy (AWSJSON) before dropping the (circular) organization object
  if (formattedRecord.organization?.exitSurveySettings !== undefined) {
    formattedRecord.exitSurveySettings = formattedRecord.organization.exitSurveySettings
  }

  // remove the organization property to avoid circular references
  delete formattedRecord.organization

  return formattedRecord
}

// --------------------------------------------------------------------------------

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.BUILDINGS_UPDATE_ALL:
      return reduceBuildingsListToObj(state, action.payload)

    case ActionTypes.BUILDINGS_SET_VIEWING:
      return setActiveBuildingById(state, action.payload)

    case ActionTypes.BUILDINGS_UPDATE:
      return updateSingleBuilding(state, action.payload)

    case ActionTypes.BUILDINGS_UPDATE_DUMMY_RESIDENT:
      return setBuildingDummyResidentId(state, action.payload.buildingId, action.payload.dummyResidentId)

    default:
      return state
  }
}
